import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export const exportToExcel = (data, fileName = 'Report.xlsx', datagetTotalSeperateAPI, currentSelectedModeObject, location_value_to_paas_to_api) => {


    const normalizeKeys = (obj) => {
        const normalized = {};
        Object.keys(obj).forEach((key) => {
            normalized[key.toLowerCase()] = obj[key];
        });
        return normalized;
    };

    // Map API data to Excel-friendly headers
    const excelData = data.map((row, index) => {

        

        let mode_to_pass_to_api = currentSelectedModeObject?.value
        if (location_value_to_paas_to_api != "-") {
            mode_to_pass_to_api = "STK_LOC_QTY_COST_ASON"
        }

        console.log("mode_to_pass_to_api", mode_to_pass_to_api)

        const r = normalizeKeys(row);

        if (mode_to_pass_to_api === "STK_MAIN_QTY_COST_ASON") {
            return {
                'Sl No': index + 1,
                'Code': r.code?.trim() || '',
                'Description': r.description?.trim() || '',
                'Unit': r.unit || '',
                'Quantity': Number(r.qty || 0),
                'Cost': Number(r.cost || 0),
                'Total': Number(r.total || 0),
                'Group': r.group || '',
                'Subgroup': r.subgroup || '',
                'Category': r.category || '',
                'Subcategory': r.subcateg || '',
                'OEM': r.oem || '',
                'HS Code': r.hscode || '',
                'Origin': r.origin?.trim() || '',
                'Specification': r.Specification?.trim(),
            }
        }

        if (mode_to_pass_to_api === "STK_LOC_QTY_COST_ASON") {
            return {
                'Sl No': index + 1,
                'Code': r.code?.trim() || '',
                'Description': r.description?.trim() || '',
                'Unit': r.unit || '',
                'Quantity': Number(r.qty || 0),
                'Cost': Number(r.cost || 0),
                'Total': Number(r.total || 0),
                'Group': r.group || '',
                'Subgroup': r.subgroup || '',
                'Category': r.category || '',
                'Subcategory': r.subcateg || '',
                'OEM': r.oem || '',
                'HS Code': r.hscode || '',
                'Origin': r.origin?.trim() || '',
                'Specification': r.specification?.trim() || '',
                'Location Bin': r.locbin || '',
            }
        }


    });

    // 2️⃣ Add EMPTY ROW (spacing)
    excelData.push({});

    // 3️⃣ Add TOTAL ROW
    excelData.push({
        'Description': 'TOTAL',
        'Quantity': Number(datagetTotalSeperateAPI[0]?.Total_Qty),
        'Total': Number(datagetTotalSeperateAPI[0]?.Total_Value).toLocaleString(
            'en-US',
            { minimumFractionDigits: 2, maximumFractionDigits: 2 }
          ),
    });

    // Convert JSON → worksheet
    const worksheet = XLSX.utils.json_to_sheet(excelData);

    // Optional: set column widths
    worksheet['!cols'] = [
        { wch: 6 },  // Sl No
        { wch: 20 }, // Code
        { wch: 50 }, // Description
        { wch: 8 },  // Unit
        { wch: 10 }, // Quantity
        { wch: 12 }, // Cost
        { wch: 12 }, // Total
        { wch: 15 }, // Group
        { wch: 15 }, // Subgroup
        { wch: 15 }, // Category
        { wch: 15 }, // Subcategory
        { wch: 15 }, // OEM
        { wch: 15 }, // HS Code
        { wch: 20 }, // Origin
        { wch: 30 }, // Specification
    ];

    // Create workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Report');

    // Generate Excel file and trigger download
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(blob, fileName);
};